import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlarmBellTimer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "alarm-bell-timer" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.505,15.862A7.369,7.369,0,0,0,18.75,18.75H.75s1.5-2.329,1.5-8.25A7.5,7.5,0,0,1,9.75,3V.75"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 17.25,
			cy: 6.75,
			r: 6
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "17.25 4.5 17.25 8.25 19.5 8.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M7.748,21.75a2.087,2.087,0,0,0,4.005,0"
		})
	]
});
export default SvgAlarmBellTimer;
